import { render, staticRenderFns } from "./WebinarList.vue?vue&type=template&id=0f54fbf2&scoped=true"
import script from "./WebinarList.vue?vue&type=script&lang=js"
export * from "./WebinarList.vue?vue&type=script&lang=js"
import style0 from "./WebinarList.vue?vue&type=style&index=0&id=0f54fbf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54fbf2",
  null
  
)

export default component.exports